(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.waitVisible()
    }

    waitVisible() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        this.renderProducts()
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }

    renderProducts() {
      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            this.initSection()
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    initSection() {
      this.adjustSwiper()
      this.slideArrows.forEach(element => {
        element.addEventListener('click', this.onArrowClicked.bind(this))
      })
      this.onResize()
    }

    disconnectedCallback() {
      this.slideArrows.forEach(element => {
        element.removeEventListener('click', this.onArrowClicked.bind(this))
      })
    }

    onResize() {
      if (this.mainSlider.swiper?.isLocked) {
        this.classList.add('locked')
      } else {
        this.classList.remove('locked')
      }
    }

    onSlideChanged() {
      this.querySelectorAll('.js-slide-arrow').forEach(element => {
        element.removeAttribute('disabled')

        if (this.mainSlider.swiper.isEnd && element.getAttribute('data-direction') == 'next') {
          element.setAttribute('disabled', true)
        }

        if (this.mainSlider.swiper.isBeginning && element.getAttribute('data-direction') == 'prev') {
          element.setAttribute('disabled', true)
        }
      })
    }

    onArrowClicked(event) {
      const direction = event.currentTarget.getAttribute('data-direction') || 'prev'
      if (direction == 'prev') {
        this.mainSlider.swiper?.slidePrev()
      } else {
        this.mainSlider.swiper?.slideNext()
      }
    }

    adjustSwiper () {
      Object.assign(this.mainSlider, {
        breakpoints: {
          750: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          990: {
            slidesPerView: 4,
            spaceBetween: 40,
          }
        },
        on: {
          resize: () => {
            this.onResize()
          },
          transitionEnd: () => {
            this.onSlideChanged()
          }
        }
      });

      this.mainSlider.initialize();
    }

    get mainSlider() {
      return this.querySelector('.js-media-slider')
    }

    get slideArrows() {
      return this.querySelectorAll('.js-slide-arrow')
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
